export default __webpack_public_path__ + "static/media/Project06.409dc0eb.jpg";